import React, {useState} from 'react';
import {Button} from 'antd';
import styles from './layout.module.less'
import store from "../store";
import {observer} from 'mobx-react';
import FormItem from './FormItem'
import RowItem from './RowItem'


// the hook
import {useTranslation} from 'react-i18next';

function FormRow() {
  const {t} = useTranslation();
  const [num, setNum] = useState(1)
  const record = {
    brand: ""
    , createdAt: ""
    , customerId: 0
    , deliveryDate: null
    , desc: ""
    , extraSn: null
    , factoryCode: ""
    , formats: ""
    , id: ''
    , isMeasure: false
    , name: ""
    , number: 1
    , product_id: null
    , catalog: "Sale"
    , isEdit: true
  }

  const addRow = () => {
    let cur = {...record}
    setNum(num + 1)
    cur.uid = num + Math.random()
    store.userAddRecords.push(cur)
  }

  const records = [...store.userAddRecords]
  return (
    <React.Fragment>
      {
        records.map((item, index) => {
          if (item.isEdit) {
            return <div key={item.id ? item.id : item.uid}><FormItem record={item} index={index}/></div>
          } else {
            return <div key={item.id ? item.id : item.uid}><RowItem record={item} index={index}/></div>
          }

        })
      }

      <div className={styles.formRowAdd}>
        <Button  onClick={addRow}>+ {t('添加新求购')}</Button>
      </div>
    </React.Fragment>
  )
}

export default observer(FormRow)
